module.exports = __webpack_public_path__ + "img/bootstrap.ee3b12f3.png";